import React, { PureComponent } from "react";
import FormCore from "@/components/display/form/formCore";
import ScGridTable from "@/components/display/table/gridTableCore";
import PropTypes from "prop-types";
import { getFirmwareList1 } from "@/fetch/fetchApi";
import RefreshGrid from "@/utils/refreshGrid";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
// import { OPERATIONS_LEVEL } from '@/utils/mapObj';
import UploadModal from "./uploadModal";
import RemarkModal from "./remarkModal";

// eslint-disable-next-line arrow-parens
@connect(state => state)
class FirmwareVersionManage extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.faultReportingList;
    this.state = {
      formConfig: null,
      typeOption: [{
        text: this.props.intl.messages.faultReportingList.operationMode1, // '全部',
        value: "",
      }, {
        text: "直流",
        value: "dc",
      }, {
        text: "交流",
        value: "ac",
      }],
      statusOption: [{
        text: this.props.intl.messages.faultReportingList.operationMode1, // '全部',
        value: "",
      }, {
        text: "正常",
        value: "1",
      }, {
        text: "禁用",
        value: "0",
      }],
      uploadVisible: false,
      remarkVisible: false,
      progressVisible: false,
      record: {},
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.setState({
      formConfig: this.initFormConfig(),
    });
    this.init();
  }

  componentDidMount() {
    const param = {
    };

    this.fetchApi(param);
  }

  init() {
    this.setState({
      tableConfig: {
        tableKey: "firmwareVersionManageTable",
        tableColumns: [
          {
            name: "固件型号", // 7'固件型号',
            key: "frameType",
            colType: "textCol",
            align: "left",
          }, {
            name: "设备型号", // '设备型号',
            key: "acDc",
            colType: "textCol",
            align: "left",
            render: (text) => {
              const text2 = text.toLowerCase();
              return text2 === "ac" ? "交流" : "直流";
            },
          }, {
            name: "CMOS类型", // 'CMOS类型',
            key: "cmosType",
            colType: "textCol",
            align: "left",
          }, {
            name: "有效版本数", // '运维等级',
            colType: "textCol",
            key: "validVersionNums",
            align: "center",
          }, {
            name: "状态", // '是否影响充电',
            key: "status",
            align: "left",
            colType: "textCol",
            render: (text) => {
              return text === 1 ? "正常" : "禁用";
            },
          }, {
            name: "创建时间", // '停止原因分类',
            key: "createTime",
            colType: "textCol",
            align: "left",
          },
          {
            name: "备注", // '备注',
            key: "info",
            colType: "tipCol",
            align: "left",
          },
          {
            name: "操作", // 操作
            key: "action",
            colType: "action", // 操作列，可定义多种操作。
            actionMap: [
              {
                type: "href",
                actionName: "详情", // 默认actionName
                // 根据grid数据 自定义显示actionName
                handler: (res) => {
                  this.setState({
                    record: res,
                  }, () => {
                    this.jumpToDetail();
                  });
                },
              },
              {
                type: "href",
                actionName: "备注", // 默认actionName
                // 根据grid数据 自定义显示actionName
                handler: (res) => {
                  this.setState({
                    record: res,
                    remarkVisible: true,
                  });
                },
              },
            ],
          },
        ],
        tableChange: () => {

        },
        tableParam: {
          pagecount: 10,
        },
        dataApi: getFirmwareList1,
        autoRefresh: !1, // 设置为true 直接加载grid数据
      },
    });
  }

  initFormConfig = () => {
    const formConfig = {
      childItems: [

        {
          type: "input",
          placeholder: "请输入固件型号", // '固件型号',
          param: {
            name: "frameType",
            type: "string",
          },
          labelName: "固件型号", // '故障名称:',
          required: false,
        },
        {
          type: "select",
          options: this.state.typeOption,
          placeholder: this.internationalization.placeholder, // '请选择:',
          param: {
            name: "acDc",
            type: "string",
          },
          defaultValue: "",
          labelName: "设备类型", // '设备类型',
          required: !1,
        },
        {
          type: "select",
          options: this.state.statusOption,
          placeholder: this.internationalization.placeholder, // '请选择:',
          param: {
            name: "status",
            type: "string",
          },
          defaultValue: "",
          labelName: "状态", // '设备类型',
          required: !1,
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "submit",
              // icon: 'search',
              text: this.internationalization.btn1, // '查询'
            },
            {
              btnType: "button",
              // icon: 'search',
              text: "上传版本", // '查询'
              handler: () => {
                this.setState({
                  uploadVisible: true,
                });
              },
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      defaultParams: {},
      tableKey: "firmwareVersionManageTable",
      // tablePage: '固件管理'
    };

    return formConfig;
  }

  fetchApi = (param) => {
    // 当设置formTarget为grid时，执行自定义提交事件。
    if (this.state.formConfig.formTarget === "grid") {
      return;
    }
    // 请求fetch 对象，带入生成参数
    // 如果在modal中的表单提交，请执行这里
    if (this.props.modalSubmit) {
      return this.props.modalSubmit(param);
    } else {
      // 如果正常页面中的表单提交，请执行下面
      return RefreshGrid(this.context.store, "firmwareVersionManageTable", param);
    }
  }

  jumpToDetail = () => {
    this.openTab({ firmwareInfo: this.state.record }, { key: "firmwareVersionList", titleText: "版本详情" });
  }

  openTab(param, e) {
    this.props.onAdd.bind(window.LayoutTab)(e, param);
  }

  refresh = () => {
    RefreshGrid(this.context.store, "firmwareVersionManageTable");
  }

  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className="page-panel">
          <ScGridTable config={this.state.tableConfig} />
        </div>
        {
        this.state.uploadVisible && (
          <UploadModal
            visible
            onCancel={() => this.setState({ uploadVisible: false })}
            refresh={this.refresh}
            jumpToDetail={this.jumpToDetail}
          />
        )
      }

        {
        this.state.remarkVisible && (
          <RemarkModal
            onCancel={() => this.setState({ remarkVisible: false })}
            refresh={this.refresh}
            record={this.state.record}
          />
        )
      }

      </div>);

    return Content;
  }
}

export default injectIntl(FirmwareVersionManage);



// WEBPACK FOOTER //
// ./src/AntD/pages/system/firmwareVersionManage/index.js